const getBase64FromUrl = async (
  url?: string
): Promise<string | ArrayBuffer | undefined> => {
  if (!url) {
    return
  }

  const data = await fetch(url)
  const blob = await data.blob()

  return new Promise<string | ArrayBuffer | undefined>(resolve => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = () => {
      const base64data = reader.result
      resolve(base64data == undefined ? undefined : base64data)
    }
  })
}

export default getBase64FromUrl
